import React from 'react';
import './Chapters.scss';
import Hyperlink from '../Hyperlink/Hyperlink';

function Chapter2() {
  const hyperlinkData = [{ href: 'https://allogene.com/', copy: 'Allogene Therapeutics' }];
  return (
    <section className="chapter">
      <h3 className="chapter-title">The Issue of Access</h3>
      <p className="chapter-paragraph">
        The key to understanding the access issue lies in the two CAR T cell therapy types:
        autologous (or “personalized”) and allogeneic (or “off-the-shelf”). “Autologous” refers to
        therapy that is derived from a patient’s own immune cells, meaning each patient’s treatment
        must be manufactured specifically for them—a significant hurdle given the complexity of cell
        manufacturing. In order for 25,000 patients to be treated, 25,000 individual manufacturing
        runs must be completed successfully. This creates a manufacturing bottleneck and shortages
        or delays in getting treatment to patients.
      </p>
      <p className="chapter-paragraph">
        It can take several weeks for a patient to receive a “manufacturing slot” for an autologous
        CAR T therapy, and several additional weeks or months for cells to be delivered to the
        patient once a manufacturing slot has been secured.
      </p>
      <p className="chapter-paragraph">
        In contrast, allogeneic products are made from immune cells sourced from healthy donors.
        They can be manufactured in large batches and frozen for on-demand delivery to any eligible
        patient. With this new type of CAR T, waiting times can be reduced to a few days and many
        more patients have the potential to be treated.
      </p>
      <p className="chapter-paragraph">
        A new survey of 50 healthcare providers from centers with CAR T capabilities commissioned by{' '}
        <Hyperlink hyperlinkData={hyperlinkData[0]} />, a biotechnology company pioneering the
        development of allogeneic CAR T products for certain types of cancer, showed that only about
        half of all eligible patients receive CAR T treatment today.
      </p>
      <p className="chapter-paragraph">
        The survey reported that of patients who received CAR T treatment, only 12% were able to
        receive treatment within one month, with approximately 40% waiting three to six months or
        longer to receive treatment. Often patients have to enroll on waiting lists, and risk
        deterioration in their health while they hope for a manufacturing slot.
      </p>
    </section>
  );
}

export default Chapter2;
